import { useEffect, useRef, useState } from 'react'

export const useTicker = (interval = 1000): number => {
  const [tick, setTick] = useState<number>(0)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(
    undefined
  )

  useEffect(() => {
    const tick = () => {
      setTick((prev) => prev + 1)
      timeoutRef.current = setTimeout(tick, interval)
    }
    tick()

    return () => clearTimeout(timeoutRef.current)
  }, [interval])

  return tick
}
